/*
 * @Author: Qzx
 * @Date: 2020-04-01 11:44:55
 * @Description: 项目相关配置信息
 * @LastEditors: Qzx
 * @LastEditTime: 2020-04-14 12:23:30
 */
// import adapterProtocol from '../utils/adapturl'
export default {
  eventid: 'summerCampLottery', // 项目唯一标识
  appid: '1001132',
  sGroupId: '13339481', // 活动唯一标识
  projectName: '夏令营活动抽奖主会场', // 活动名称
  description: '夏令营活动抽奖主会场', // 项目相关描述
  developer: 'gaoqing6', // 参与项目开发者
  // 活动分享相关
  xesShare: {
    title: '每日好礼大放送', // 标题
    desc: '就在学而思暑期夏令营', // 描述
    link: location.href, // （短）链接
    imgUrl: 'https://editor.xesimg.com/tailor/resource/share-icon-1623041925884.png', // 微信分享图标
    iconUrl: 'https://editor.xesimg.com/tailor/resource/share-mini-1623042105889.png' // 链接icon或分享图片或小程序预览图
  },
  // 日志打点相关(展现)
  xesLog: {
    pages: {
      home: {
        uid: 100,
        name: '活动首页',
        level: 1
      }
    }
  }
}
